export const TABLE_KEYS = {
  CELL: 'Cell',
  HEADER: 'Header',
};
